<template lang="html">
  <div class="container">
    <div v-if="loading">
      Loading
    </div>
    <div v-else-if="!isAlreadySubmitted" class="container-content">
      <div class="image"><img src="/static/images/elements/BAT-rus-logo.jpg" alt=""></div>
      <h1>Battle of minds business plan upload</h1>
      <div class="group">
        <input type="url"
          v-validate="{required: true, url: true}"
          v-model="videoLink"
          :class="{ 'error': errors.has('link'), 'valid': fields.link && fields.link.touched ? fields.link.valid : false }"
          name="link"
          id="link"
        >
          <span class="bar"></span>
          <label class="placeholder" for="link">Link on video (youtube prefered)</label>
          <label class="helper" v-if="errors.has('link') && errors.first('link')">{{ errors.first('link') }}</label>
      </div>

      <div class="group right-icon">
        <input type="text"
          v-model="fileName"
          :class="{ 'error': errors.has('documentation'), 'valid': fields.documentation ? fields.documentation.valid : null }"
          disabled>
        <input type="file"
          v-validate="{ required: true, size: 5120, mimes: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']}"
          accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          @change="uploadFile($event.target.files)"
          :class="{ 'error': errors.has('documentation'), 'valid': fields.documentation ? fields.documentation.valid : null }"
          name="documentation"
          id="documentation"
        >
        <label for="documentation"> <i class="icon icon-upload"></i> </label>

        <span class="bar"></span>
        <label class="placeholder" for="documentation">Attach your written documentation pdf, doc(x) </label>
        <label class="helper" v-if="errors.has('documentation')">{{ errors.first('documentation') }}</label>
      </div>

      <div class="line register">
        <button class="vcv-button" @click="send" :disabled="!sendButtonEnabled">
          <span> Send </span>
        </button>
      </div>
    </div>
    <div v-else class="submitted">
      Thank you for taking part! We’ve now received your video and written business plan. Keep an eye on your emails for your video approval and next steps.
    </div>
  </div>
</template>

<script>

export default {
  name: 'business-plan-upload-scene',

  props: {
    token: String
  },

  data () {
    return {
      videoLink: '',
      file: null,
      fileName: ''
    }
  },

  computed: {
    store () {
      return this.$store.state.process.batChampionship.businessPlan
    },

    isAlreadySubmitted () {
      return this.$store.getters['process/batChampionship/businessPlan/isAlreadySubmitted']
    },

    loading () {
      return this.store.loading
    },

    error () {
      return this.store.error
    },

    sendButtonEnabled () {
      return Object.keys(this.fields).every(key => this.fields[key].valid)
    }
  },

  methods: {
    fetch () {
      this.$store.dispatch('process/batChampionship/businessPlan/fetch', this.token)
    },

    send () {
      this.$store.dispatch(
        'process/batChampionship/businessPlan/upload',
        {
          token: this.token,
          video_link: this.videoLink,
          file: this.file
        }
      )
    },

    uploadFile (files) {
      if (files.length) {
        this.file = files[0]
        this.fileName = this.file.name
      } else {
        this.file = null
        this.fileName = ''
      }
    }
  },

  beforeMount () {
    this.fetch()
    // st englosh locale as it should use only it
    this.$store.dispatch('locale/change', 'en')

  // @TODO remove this use default message
    this.$validator.localize({
      'en': {
        messages: {
          size: () => 'The documentation size must be less than 5 Mb.'
        }
      }
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

input {
  border-radius: 0;
}

.content-wrapper {
  .container {
    max-width: 440px;
    width: 440px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px 30px 80px 30px;

    .container-content {
      width: 100%;
    }
  }
}

.container {
  .image {
    text-align: center;
  }

  img {
    max-width: 100%;
    max-height: 200px;
  }

  h1 {
    font-size: 24px;
    font-weight: normal;
    margin: 22px 0 34px;
  }

  .group {
    position: relative;
    margin: 10px 0;

    input[type='url'],
    input[type='text'] {
      font-size: 16px;
      margin: 0;
      padding: 32px 0 16px;
      display: block;
      width: 440px;
      border: none;
      border-bottom: 2px solid #edeff3;

      &:focus {
        outline: none;
      }

      &:focus ~ label.placeholder,
      &.valid ~ label.placeholder,
      &.error ~ label.placeholder {
        top: 0;
        font-size: 14px;
      }

      &:focus ~ .bar:before,
      &.valid ~ .bar:before {
        width: 100%;
      }

      &.error {
        border-bottom: 2px solid #ed6f6e;

        & ~ .bar:before {
          background: #ed6f6e;
        }

        & ~ label {
          color: #ed6f6e;
        }

        & ~ label.helper {
          display: block;
        }
      }

      &:disabled {
        background-color: inherit;
      }
    }

    input[type='file'] {
      width: 0.1px;
      height: 0.1px;
      opacity: 0;
      overflow: hidden;
      position: absolute;
      z-index: -1;

      + label .icon-upload {
        display: block;
        position: absolute;
        cursor: pointer;
        right: 0;
        top: 34px;
        width: 24px;
        font-size: 21px;
        color: $green;
        height: 24px;
      }
    }

    input.error + input[type='file'] {
      + label .icon-upload {
        color: $red-color;
      }
    }

    label.placeholder {
      margin: 0;
      color: #a6a6a6;
      font-size: 16px;
      font-weight: 300;
      position: absolute;
      pointer-events: none;
      top: 36px;
      transition: 0.2s ease all;
    }

    label.helper {
      margin: 0;
      color: #ed6f6e;
      font-size: 12px;
      font-weight: normal;
      padding-top: 5px;
    }

    .bar {
      position: relative;
      display: block;
      width: 440px;

      &:before {
        left: 0;
        content: '';
        height: 2px;
        width: 0;
        bottom: 0;
        position: absolute;
        background: $green;
        transition: 0.2s ease all;
      }
    }

    &.right-icon {
      input[type='url'],
      label.placeholder {
        padding-right: 25px;
      }
    }
  }

  button.vcv-button {
    font-weight: normal;
    text-transform: uppercase;
  }

  .line {
    display: flex;
    margin: 0;
    align-items: center;
    margin-top: 40px;
    width: 100%;

    & .line-right {
      margin-left: auto;
    }

    &.register {
      .line-right {
        padding-left: 20px;
        color: $light-link-color;
        font-size: 12px;
      }
    }
  }

  p.link {
    margin-top: 25px;
    font-size: 12px;
    font-weight: 300;
    color: #a6a6a6;
  }

  p.terms {
    margin-top: 18px;
    font-size: 10px;
    font-weight: 300;
    color: #a6a6a6;
  }
}

.column-checkbox {
  display: flex;

  span {
    width: calc(100% - 20px);
  }
}
</style>
